// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  merchantPaymentFormSchema,
  MerchantPaymentValuesType,
  merchantPaymentInitialValues,
} from "./_formTypes";
import {
  useGetPayment3DTrxSettingsList,
  useGetAcquirerBankList,
  GetMerchantPaymentRequest,
  useGetMerchantPayment,
  useCancelPaymentAndTransaction,
  CancelPaymentAndTransactionRequest,
  useRefundPaymentAndTransaction,
  RefundPaymentAndTransactionRequest,
  useGetTrxStatusSettingsList,
  BasePagingResponse,
  PagingResponse,
  useAuthorization,
  useGetAllMerchantList,
  useSendMoney,
  useGetMerchantsWithParentMerchant,
  useAddTransactionReportRequest,
  postTransactionReportRequestList,
  useGetMerchantEarningsReport,
  IGetMerchantEarningsReportRequest,
} from "../../../hooks";
import {
  GridColDef,
  GridActionsCellItem,
  GridValueFormatterParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
  FormControl,
  Link,
  Box,
  useTheme,
  useMediaQuery,
  Autocomplete,
  TextField,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Checkbox,
  Button as MaterialButton
} from "@mui/material";
import { Button, Loading } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  DateTimePickerControl,
  Table,
  DeleteConfirmModal,
  InputControl,
  NumericFormatInputControl,
  MechantPaymentModal,
  DatePickerControl,
  createBooleanOperator,
  TextAreaInputControl,
  ReportRequestListModal
} from "../../molecules";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import BarChartIcon from '@mui/icons-material/BarChart';
import AddchartIcon from '@mui/icons-material/Addchart';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';

export const MerchantSettlementComponent = () => {
  const theme = useTheme();
  const user = useLocation().state as unknown as IUser | undefined;
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const { control, handleSubmit, setValue, getValues } =
    useForm<MerchantPaymentValuesType>({
      resolver: zodResolver(merchantPaymentFormSchema),
      defaultValues: merchantPaymentInitialValues,
    });
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [tableselectedRow, setTableSelectedRow] = useState({} as any);
  const { mutate: GetMerchantPayment, isLoading: isGetMerchantPaymentLoading } =
    useGetMerchantPayment();
  const { mutate: GetMerchantEarningsReport, isLoading: isGetMerchantEarningsReportLoading } =
    useGetMerchantEarningsReport();
  const { mutate: sendMoney, isLoading: isGetSendMoneyLoading } =
    useSendMoney();
  const { mutate: addTransactionReportRequest, isLoading: isAddTransactionReportRequestLoading } =
    useAddTransactionReportRequest();
  const setSnackbar = useSetSnackBar();
  const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant();
  const [userInfo] = useUserInfo();
  const [openDialog, setOpenDialog] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const [isReportListActive, setIsReportListActive] = useState(false);
  const [dynamicFilters, setDynamicFilter] = useState([]);
  const [reportFiles, setReportFiles] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(
    user
      ? Number(userInfo.merchantId) !== 0
        ? { label: userInfo.merchantName, value: Number(userInfo.merchantId) }
        : null
      : null
  );

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmPay = () => {
    setOpenDialog(false);
  };

  const merchantList = useMemo(() => {
    return rawMerchantList?.data?.map(
      (rawPosType: { merchantName: string; merchantId: number }) => {
        return {
          label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
          value: rawPosType.merchantId,
        };
      }
    );
  }, [rawMerchantList?.data]);


  const [formValues, setFormValues] =
    useState<IGetMerchantEarningsReportRequest | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onSubmit = (data: MerchantPaymentValuesType) => {
    setFilterAccordionExpand(false);
    setTableData(undefined);
    setShowTable(true)

    const filterMerchantId = Array.isArray(data.filterMerchantId) ? data.filterMerchantId : [data.filterMerchantId ?? 0];

    const merchantIdsString = filterMerchantId.length > 0 && filterMerchantId[0] !== 0
      ? filterMerchantId.join(',')
      : '';

    const req: IGetMerchantEarningsReportRequest = {
      page: paginationModel.page,
      size: paginationModel.pageSize,
      orderByDesc: true,
      orderBy: "CreateDate",
      status: data.status || "",
      merchantIds: merchantIdsString,
    };

    if (data?.startPaymentMerchantDate) {
      req.startDate = dayjs(data.startPaymentMerchantDate).format("YYYY-MM-DD");
    }

    if (data?.endPaymentMerchantDate) {
      req.endDate = dayjs(data.endPaymentMerchantDate).format("YYYY-MM-DD");
    }

    console.log("Form data:", data);
    console.log("Request payload:", req);

    setFormValues(req);
    setIsSubmitted(true);
  };
  useEffect(() => {
    if (!isSubmitted || formValues == null) {
      return;
    }
    const requestPayload = {
      ...formValues,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    GetMerchantEarningsReport(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setTableData(data.data);
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }, [formValues, isSubmitted, queryOptions, shouldRefresh]);

  const deleteRow = React.useCallback(
    (transaction: any) => () => {
      setTableSelectedRow(transaction);
    },
    []
  );
  const booleanOptions = [
    { label: "Evet", value: true },
    { label: "Hayır", value: "false" },
  ];
  const currencyDesc = [
    { label: "TRY", value: "TRY" },
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" }
  ];

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "merchantId",
        headerName: "Üye İşyeri ID",
        width: 180,
        resizable: true,
        renderCell: (params) => params.value || "N/A",
      },
      {
        field: "merchantName",
        headerName: "Üye İşyeri Adı",
        resizable: true,
        width: 300,
        renderCell: (params) => params.value || "N/A",
      },
      {
        field: "paymentMerchantDate",
        headerName: "Ödeme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      {
        field: "merchantAmount",
        headerName: "Ödeme Tutarı",
        type: "decimal",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "paidAmount",
        headerName: "Ödenen Tutar",
        type: "decimal",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
    ];
  }, [deleteRow, showDelete]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);

    const data = getValues();
    const filterMerchantId = Array.isArray(data.filterMerchantId) ? data.filterMerchantId : [data.filterMerchantId ?? 0];
    const merchantIdsString = filterMerchantId.length > 0 && filterMerchantId[0] !== 0
      ? filterMerchantId.join(',')
      : '';

    const requestPayload: IGetMerchantEarningsReportRequest = {
      page: model.page,
      size: model.pageSize,
      orderByDesc: true,
      orderBy: "CreateDate",
      status: data.status || "",
      merchantIds: merchantIdsString,
    };

    if (data.startPaymentMerchantDate) {
      requestPayload.startDate = dayjs(data.startPaymentMerchantDate).format("YYYY-MM-DD");
    }

    if (data.endPaymentMerchantDate) {
      requestPayload.endDate = dayjs(data.endPaymentMerchantDate).format("YYYY-MM-DD");
    }

    GetMerchantEarningsReport(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };
  const decimalFields = [
    'merchantAmount',
    'paidAmount',
  ]

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      let value = filters[key];
      if (value === "false") {
        queryParams[key] = false;
      } else if (key === "merchantId") {
        queryParams[key] = Array.isArray(value) ? value.map(Number) : [Number(value)];
      } else if (value !== null && value !== undefined && value.toString().length > 0) {
        if (decimalFields.includes(key) && !isNaN(parseFloat(value))) {
          queryParams[key] = parseFloat(value);
        } else {
          queryParams[key] = value;
        }
      }
    }
    return queryParams;
  };

  const convertTableFiltersToRequestFilter = (tableFilters) => {
    let convertedFilters = [];

    tableFilters.items.map((item) => {
      var findColumn = columns.find(x => x.field == item.field);

      convertedFilters.push({
        field: item.field,
        values: [item.value.toString()],
        valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
        operationType: mapReactMUIToFilterOperationTypes(item.operator)
      });
    });

    return convertedFilters;
  };
  const keyRules = {
    'merchantAmount': 1,
    'paidAmount': 1
  };

  const handleFilterChange = debounce((filters, tableFilters) => {
    if (filters.clearFilter) {
      setDynamicFilter([]);
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);

    const isValueValid = (key, value) => {
      const minLength = keyRules[key] || 3;
      return value?.toString().length >= minLength;
    }

    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
      if (tableFilters && tableFilters.items) {
        setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
      }
    }

    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  const previousQueryParams = React.useRef({});
  const hasLoading = isGetMerchantPaymentLoading || isGetMerchantEarningsReportLoading || isGetSendMoneyLoading || isAddTransactionReportRequestLoading;

  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);

  const createReportRequest = () => {
    const data = getValues();
    const filterMerchantId = Array.isArray(data.filterMerchantId) ? data.filterMerchantId : [data.filterMerchantId ?? 0];

    const req = {
      page: 0,
      size: -1,
      reportType: 3,
      filters: [
        ...dynamicFilters
      ]
    };

    if (filterMerchantId.length > 0 && filterMerchantId[0] !== 0) {
      req.filters.push({
        field: "merchantIds",
        values: [filterMerchantId.join(',')],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.startPaymentMerchantDate) {
      req.filters.push({
        field: "startDate",
        values: [dayjs(data.startPaymentMerchantDate).format("YYYY-MM-DD")],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.endPaymentMerchantDate) {
      req.filters.push({
        field: "endDate",
        values: [dayjs(data.endPaymentMerchantDate).format("YYYY-MM-DD")],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.status) {
      req.filters.push({
        field: "status",
        values: [data.status],
        operationType: 1,
        valueType: 1
      });
    }

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      req.filters.push({
        field: queryOptions.field,
        values: [queryOptions.value.toString()],
        operationType: 1,
        valueType: typeof queryOptions.value === 'number' ? 2 : 1
      });
    }

    addTransactionReportRequest(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setSnackbar({
            severity: "info",
            isOpen: true,
            description: data.data || "Rapor oluşturma isteği başarıyla gönderildi",
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message || "Rapor oluşturma sırasında bir hata oluştu",
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const getReportList = () => {
    postTransactionReportRequestList({
      page: 0,
      size: -1,
      reportType: 3,
    })
      .then((data) => {
        setReportFiles(data.data.result);
        setIsReportListActive(true);
      })
      .catch(() => {
        setSnackbar({
          severity: "error",
          description: "Rapor listesi alınırken hata oluştu",
          isOpen: true,
        });
      });
  };

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>

          <BaseFilterTableWithAccordion summary="İşyeri Hak Ediş Raporları" isExpanded={isFilterAccordionExpanded} setExpanded={setFilterAccordionExpand} setTableVisibility={setShowTable}
            child={<Stack spacing={4}>
              <Stack
                spacing={5}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 800 : "auto"}
              >
                <FormControl sx={{ flex: 1 }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="startPaymentMerchantDate"
                    control={control}
                    label="Başlangıç Tarihi"
                    defaultValue={dayjs().subtract(1, "day")}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1 }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="endPaymentMerchantDate"
                    control={control}
                    label="Bitiş Tarihi"
                    defaultValue={dayjs()}
                  />
                </FormControl>
              </Stack>

              <Stack
                spacing={1}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 800 : "auto"}
              >
                <FormControl sx={{ flex: 1 }}>
                  {merchantList && (
                    <Controller
                      control={control}
                      name="filterMerchantId"
                      render={({ field }) => (
                        <Autocomplete
                          multiple
                          id="merchant-multi-checkbox"
                          options={merchantList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) => {
                            field.onChange(newValue.map((item) => item.value));
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.value}>
                              <Checkbox
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} label="Üye İşyeri" placeholder="Seçiniz" />
                          )}
                        />
                      )}
                    />
                  )}
                </FormControl>
              </Stack>

              <Stack
                direction="row"
                justifyContent="flex-end"
                width={isDesktop ? 800 : "auto"}
              >
                <Button
                  onClick={handleSubmit(onSubmit)}
                  variant="contained"
                  text={"ARA"}
                />
              </Stack>
            </Stack>} />

          <Stack flex={1} mt={2}>

            <>
              {showTable && (
                <>
                  <Table
                    columnVisibilityConfigKey="MerchantSettlementColumnVisibilityKey"
                    className="myTable"
                    hasActiveFilters={hasActiveFilters}
                    handleFilterChange={handleFilterChange}
                    paginationModel={paginationModel}
                    onPaginationModelChange={handleChangePagination}
                    paginationMode="server"
                    rowCount={tableData?.totalItems}
                    getRowId={(row) => `${row.merchantId || 'null'}-${row.paymentMerchantDate}`}
                    disableRowSelectionOnClick
                    sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
                    checkboxSelection
                    onRowSelectionModelChange={(ids) => {
                      const selectedIDs = new Set(ids);
                      const newSelectedRows = tableData?.result.filter((row) => selectedIDs.has(`${row.merchantId || 'null'}-${row.paymentMerchantDate}`));
                      setSelectedRows(newSelectedRows);
                    }}
                    {...tableData?.result}
                    openDialog={setOpenDialog}
                    selectedRows={selectedRows}
                    showBulkPayButton={false}
                    rows={tableData?.result || []}
                    autoHeight={!isDesktop}
                    customLabelDisplayedRows={true}
                    columns={columns}
                    exportFileName="İşyeri Hakediş Raporu"
                    extraToolbarButton={<>
                      <MaterialButton sx={{ marginLeft: 2 }} onClick={() => createReportRequest()}>
                        <AddchartIcon color="primary" />
                        RAPOR OLUŞTUR
                      </MaterialButton>
                      <MaterialButton sx={{ marginLeft: 2 }} onClick={() => { getReportList(); }}>
                        <BarChartIcon color="primary" />
                        RAPORLAR
                      </MaterialButton>
                    </>}
                  />
                  <ReportRequestListModal
                    isOpen={isReportListActive}
                    onClose={() => { setIsReportListActive(false); }}
                    title="Raporlar"
                    reportFiles={reportFiles}
                    closeButtonText="Kapat"
                    reportType={3}
                  />
                </>
              )}
            </>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
